// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pnvydTMb8prS7HTkR33d {\n\tmargin-inline-end: 0;\n\tmin-width: 24px;\n\ttext-align: center;\n}\n", "",{"version":3,"sources":["webpack://./client/src/screens/estimates/details/components/styles/CargoContractStatusTag.module.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;CACpB,eAAe;CACf,kBAAkB;AACnB","sourcesContent":[".tag {\n\tmargin-inline-end: 0;\n\tmin-width: 24px;\n\ttext-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tag": "pnvydTMb8prS7HTkR33d"
};
export default ___CSS_LOADER_EXPORT___;
